module.exports = __webpack_public_path__ + "static/media/United States of America.aefba3fe.svg";